import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'success' | 'brand';
export type ButtonSize = 'md' | 'sm';

/** The Button look for elements that cannot be a `<button>` (router links, file-input labels). */
export function buttonClassName(variant: ButtonVariant, size: ButtonSize = 'md'): string {
  return [styles.button, styles[variant], size === 'sm' ? styles.sm : ''].filter(Boolean).join(' ');
}
